import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconButton } from '@angular/material/button';

@Component({
  selector: 'app-filter-button',
  templateUrl: './filter-button.component.html',
  styleUrl: './filter-button.component.scss',
  imports: [MatIconButton, MatTooltip, NgClass, MatIcon],
})
export class FilterButtonComponent {
  @Input() appliedFiltersCount: number;
  @Input() active: boolean;
  @Output() toggled = new EventEmitter();

  onClick() {
    this.toggled.emit();
  }
}
